import React from 'react';
const Salons = () => <div className="service-page"><h1>Salons</h1><p>Top salons for hair, beauty, and grooming services.</p></div>;
export default Salons;
